import { List, Edit, Create } from "../Components/index.js";

export default [
    {
        path: "/vehicle-drivers/list",
        component: List,
        name: "vehicle-drivers",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/vehicle-drivers/:id/edit",
        component: Edit,
        name: "vehicle-drivers-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/vehicle-drivers/create",
        component: Create,
        name: "vehicle-drivers-create",
        meta: {
            requiresAuth: true,
        },
    },
];
